import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/community/sponsorship/SponsorshipApplicationForm.tsx");
